import React from 'react'
import LabsLeading from './LabsLeading'
import PharmaciesLeading from './PharmaciesLeading'
import ProvidersLeading from './ProvidersLeading'

export type SubtitleLeadingKey = 'labs' | 'pharmacies' | 'providers'

const SUBTITLE_LEADING_REGISTRY: Record<SubtitleLeadingKey, () => React.ReactElement> = {
    labs: () => <LabsLeading />,
    pharmacies: () => <PharmaciesLeading />,
    providers: () => <ProvidersLeading />,
}

interface SubtitleLeadingProps {
    leading: SubtitleLeadingKey
}

export default function SubtitleLeading({ leading }: SubtitleLeadingProps) {
    const renderLeading = SUBTITLE_LEADING_REGISTRY[leading]
    if (renderLeading == null) return null
    return renderLeading()
}
